import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  private boolValue = new BehaviorSubject<any>(false);
  _boolValue = this.boolValue.asObservable();

  constructor() { }

  emitBoolValue(value: boolean) {
    this.boolValue.next(value);
  }

}
